import Modal from '../common/Modal';

const RejectedCandidateModal = ({
  name,
  exp = '-',
  reason = '-',
  text = '',
  ...restModalProps
}) => {
  return (
    <Modal {...restModalProps}>
      <div className="grid grid-cols-1 gap-4">
        <div className="flex">
          <div className="basis-1/2 font-semibold">Name:</div>
          <div className="basis-1/2 ">{name}</div>
        </div>
        <div className="flex">
          <div className="basis-1/2 font-semibold">Experience:</div>
          <div className="basis-1/2 ">{exp}</div>
        </div>
        <div className="flex">
          <div className="basis-1/2 font-semibold">Reason for {text}:</div>
          <div className="basis-1/2 ">{reason}</div>
        </div>
      </div>
    </Modal>
  );
};

export default RejectedCandidateModal;
